var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC208",
    fillRule: "nonzero",
    d: "M5.18804385,4.85938643e-06 L18.8074974,0.0186463171 C21.6633186,0.0225551869 23.9774447,2.3366813 23.9813536,5.19250249 L23.999995,18.8119563 C24.0039115,21.6733146 21.6874972,23.9960787 18.8261389,23.9999951 C18.8214113,24.0000016 18.8166837,24.0000016 18.8119561,23.9999951 L5.19250259,23.9813537 C2.33668141,23.9774448 0.0225552926,21.6633187 0.0186464229,18.8074975 L4.96523558e-06,5.18804374 C-0.00391148331,2.32668544 2.31250283,0.00392130793 5.17386114,4.85938626e-06 C5.17858871,-1.61141549e-06 5.18331628,-1.61141543e-06 5.18804385,4.85938643e-06 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillRule: "nonzero",
    points: "18 6 18 10 14 10 14 19 10 19 10 10 6 10 6 6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRank);
export default __webpack_public_path__ + "static/media/icon-rank.08d21fbc.svg";
export { ForwardRef as ReactComponent };